import { cn } from '@/lib/utils';
import Dot from '@/components/ui/Dot.tsx';

interface StepBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Numer kroku liczony od 1. */
  current: number;
  total: number;
  /** Dopisek obok odznaki, np. „Paczka #13 · szkic”. */
  context?: React.ReactNode;
}

/**
 * Odznaka „Krok N z M" z dopiskiem kontekstowym — nagłówek kroku w każdym
 * wieloetapowym przepływie (wprowadzanie paczki zmian, kreator wyjazdu,
 * publiczna rezerwacja).
 */
const StepBadge = ({
  current,
  total,
  context,
  className,
  ...props
}: StepBadgeProps) => (
  <div className={cn('flex items-center gap-2.5', className)} {...props}>
    <span className="inline-flex items-center gap-[7px] rounded-full bg-accent-200 px-2.5 py-1 text-xs font-bold uppercase tracking-[.06em] text-accent-900">
      <Dot size="sm" hollow />
      {`Krok ${current} z ${total}`}
    </span>
    {context && <span className="text-[13px] text-neutral-500">{context}</span>}
  </div>
);

export default StepBadge;
